import { SupplierApiError, mapSupplierApiError, supplierGetRaw } from './supplierApiCore';

// GET /supplier/diagrams/:diagramId (S7 item 1) — tenant-scoped read of an
// operator's diagram, including their immutable supplier source-evidence
// diagrams (S6), which the legacy `GET /diagrams/:id` (declarant/operator
// dashboard route) 404s on. The response mirrors that legacy route's payload
// envelope byte-for-byte (see backend/src/api/freeSupplier/diagrams.ts) — it
// is NOT one of the S5/S6 versioned V1 contracts, so there is deliberately no
// zod schema here; callers (useSupplierDiagram) must read the result defensively.

export const SUPPLIER_DIAGRAM_ENDPOINTS = Object.freeze({
  get: (diagramId) => `/supplier/diagrams/${diagramId}`,
});

export class SupplierDiagramApiError extends SupplierApiError {
  constructor(payload, httpStatus) {
    super(payload, httpStatus, 'Supplier diagram request failed');
    this.name = 'SupplierDiagramApiError';
  }
}

const mapApiError = (error) => mapSupplierApiError(error, SupplierDiagramApiError);

export const fetchSupplierDiagram = (diagramId) =>
  supplierGetRaw(SUPPLIER_DIAGRAM_ENDPOINTS.get(diagramId), mapApiError);
